/**
 * frontend/lib/authRedirectError.js — the error Supabase put in the sign-in redirect URL.
 *
 * An expired / reused / scanner-pre-clicked magic link lands on
 *   /auth/callback#error=access_denied&error_code=otp_expired&error_description=…
 * (or the same keys in the query string). Read once at module load — index.js imports this
 * before App, so it runs before the Supabase client is created and can touch the URL.
 */

export function parseAuthRedirectError(loc) {
  const { hash = '', search = '' } = loc || {};
  for (const part of [hash.replace(/^#/, ''), search.replace(/^\?/, '')]) {
    if (!part) continue;
    const p = new URLSearchParams(part);
    const error = p.get('error');
    const code = p.get('error_code');
    const description = p.get('error_description');
    if (error || code || description) return { error, code, description };
  }
  return null;
}

const BOOT = typeof window !== 'undefined' && window.location?.pathname?.startsWith('/auth/callback')
  ? parseAuthRedirectError(window.location)
  : null;

/** The error captured when the app booted on /auth/callback (or null). */
export function bootAuthRedirectError() {
  return BOOT;
}
